import {createStyles, Group} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import PlainSearchInput, {ClearType} from 'ui-library/PlainSearchInput';
import {GenericEvent} from 'util/Types';

const useStyles = createStyles({
  header: {
    lineHeight: '24px',
    width: '100%',
    marginLeft: 3,
  },
});

export enum ContainerRelevantItemsFilterOption {
  ALL = 'All',
  ENTRIES = 'Entries',
  WORKSHEET_STEPS = 'Worksheet steps',
  PROCESSES = 'Task groups',
  ENTITY_LINKS = 'Entity links',
}

export interface ContainerRelevantItemsFilteredTableState {
  searchQuery: string;
  filterOption: ContainerRelevantItemsFilterOption;
  pageOffset: number;
}

export const containerRelevantItemsFilteredTableState =
  makeUseGlobalClientState<ContainerRelevantItemsFilteredTableState>({
    searchQuery: '',
    filterOption: ContainerRelevantItemsFilterOption.ALL,
    pageOffset: 0,
  });

export interface ContainerRelevantItemsSectionHeaderProps {
  filteredTableState: ContainerRelevantItemsFilteredTableState;
  setFilteredTableState: (state: ContainerRelevantItemsFilteredTableState) => void;
}

export default function ContainerRelevantItemsSectionHeader(
  props: ContainerRelevantItemsSectionHeaderProps
): JSX.Element {
  const {classes} = useStyles();
  const {filterOption, searchQuery} = props.filteredTableState;
  const filteredMenuOptions = Object.values(ContainerRelevantItemsFilterOption)
    .filter(
      (option) =>
        option !== ContainerRelevantItemsFilterOption.WORKSHEET_STEPS ||
        BenchlingConfig.ELN_ENABLE_DOCUMENT_NOTE_REFERENCES
    )
    .filter(
      (option) => option !== ContainerRelevantItemsFilterOption.PROCESSES || BenchlingConfig.WORKFLOWS_ENABLE
    );

  return (
    <div className={classes.header}>
      <Group position="apart" align="center" mb="sm">
        <Group align="center">
          <SelectDropdown
            className="u-display-inline-block"
            displayName={filterOption}
            menu={
              <Menu width={MenuWidth.MEDIUM}>
                {filteredMenuOptions.map((option) => (
                  <Option
                    key={option}
                    onSelect={() => {
                      props.setFilteredTableState({filterOption: option, searchQuery, pageOffset: 0});
                    }}
                  >
                    {option}
                  </Option>
                ))}
              </Menu>
            }
          />
        </Group>
        <Group align="center" spacing="xs">
          <PlainSearchInput
            clearType={ClearType.X}
            placeholder="Search"
            onChange={(e: GenericEvent) => {
              props.setFilteredTableState({
                filterOption,
                searchQuery: e.target.value,
                pageOffset: 0,
              });
            }}
            onEscape={() => {
              props.setFilteredTableState({
                filterOption,
                searchQuery: '',
                pageOffset: 0,
              });
            }}
            value={searchQuery}
          />
        </Group>
      </Group>
    </div>
  );
}
